module.exports = __webpack_public_path__ + "media/images/print_hub_bg-cd35c361614d34395ad75e3dcc0d9257.png";